import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo Api 傳入值
 */
export interface FillBasicDataPostBackReq {
    base64Data: string;
}
/**
 * @todo Api 回傳值
 */
export interface FillBasicDataPostBackResp extends GeneralResp {}

/**
 * @todo 填寫基本資料
 */
const FillBasicDataPostBack = (data: FillBasicDataPostBackReq): Promise<FillBasicDataPostBackResp> => {
    const url = RouteUrlList.API_FillBasicPostBack.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, data, config).then((res: AxiosResponse<FillBasicDataPostBackResp>) => {
        return res.data;
    });
};

export default FillBasicDataPostBack;
